import './Link.css'

export interface LinkProps {
  title: string
  href: string
  target?: '_blank' | '_self' | '_parent' | '_top'
  className?: string
  children?: React.ReactNode
  text?: string
}

function Link({ 
  title, 
  href, 
  target = '_self',
  className = '',
  children,
  text
}: LinkProps) {
  const isExternal = target === '_blank';
  return (
    <a 
      href={href}
      target={target}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      title={title}
      className={`${className}`}
    >
      {children || text || title}
      {isExternal && (
        <span className="external-link-icon" aria-hidden="true" style={{ marginLeft: 2, marginRight: 2, fontSize: '0.8em', opacity: 0.7 }}>
          ↗
        </span>
      )}
    </a>
  )
}

export default Link
